import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import HomePage from "./Patient/HomePage";
import Login from "./Patient/Login";
import Dashboard from "./Patient/Dashboard";
import NotRegister from "./Patient/NotRegister";
import Notification from "./Patient/Notification";
import RLogin from "./Recipient/RLogin";
import Register from "./Recipient/Register";
import Detail from "./Doctor/Detail";
import NotificationPage from "./Patient/Notification";




function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/dashboard" element={<Dashboard/>} />
        <Route path="/notregister" element={<NotRegister/>} />
        <Route path="/notification" element={<Notification/>} />
        <Route path="/stafflogin" element={<RLogin/>} />
        <Route path="/patientregister" element={<Register/>} />
        <Route path="/doctortoken" element={<Detail/>} />
        <Route path="/notifications" element={<NotificationPage />} />
      </Routes>
    </Router>
  );
}
console.log(Dashboard, typeof Dashboard);

export default App;
